import * as yup from 'yup';
import { FIELD_REQUIRED_MSG } from '../../validation';

export const schema = yup.object().shape({
  gender: yup.string().required(FIELD_REQUIRED_MSG),
  name: yup.string().required('pup name is required'),
});
